import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import * as jp from 'json-p3/dist/json-p3.esm'

const useStyles = makeStyles(() => ({
  readonlyField: {
    padding: 'var(--padding-md)',
    backgroundColor: 'var(--color-surface-100)',
    borderRadius: 'var(--border-radius-sm)',
    color: 'var(--color-neutral-800)',
    fontSize: 'var(--text-size-md)',
    marginBottom: 'var(--margin-md)'
  },
  label: {
    fontWeight: 'var(--text-weight-bold)',
    marginRight: 'var(--margin-sm)'
  }
}))

function ReadonlyAccessorEditor ({ field, initializationData }) {
  const classes = useStyles()

  const value = useMemo(() => {
    if (!initializationData || !field.accessor) {
      return null
    }

    try {
      // json-p3 query syntax: query(path, data)
      const results = jp.query(field.accessor, initializationData)
      // Results are objects with { value, location, root }
      return results?.nodes[0]?.value ?? null
    } catch (error) {
      console.error('Error evaluating JSON path:', error)
      return null
    }
  }, [initializationData, field.accessor])

  return (
    <div className={classes.readonlyField}>
      {field.label && <span className={classes.label}>{field.label}:</span>}
      <span>{value ?? 'N/A'}</span>
    </div>
  )
}

ReadonlyAccessorEditor.propTypes = {
  field: PropTypes.shape({
    label: PropTypes.string,
    accessor: PropTypes.string.isRequired
  }).isRequired,
  initializationData: PropTypes.any
}

export default ReadonlyAccessorEditor
